enum RequestType {
  Commercial = 'commercial',
  Accounting = 'accounting',
  Production = 'production',
  Technical = 'technical',
}

interface RequestUpdateOptions {
  status: RequestStatus;
  closedReason?: string;
}

interface ClosedReason {
  initiatorId: string;
  initiatorType: string;
  details: string;
  date: string;
}

interface BaseRequest {
  id: string;
  subject: string;
  message: string;
  creatorId: string;
  urgency: number;
  attachmentsIds?: string[];
  createdAt: string;
  updatedAt?: string;
  status: RequestStatus;
  closedReason?: ClosedReason;
  issueId?: string;
  siteId: string;
}

interface CommercialRequest extends BaseRequest {
  type: RequestType.Commercial;
}

interface AccountingRequest extends BaseRequest {
  type: RequestType.Accounting;
}

interface ProductionRequest extends BaseRequest {
  type: RequestType.Production;
  orderId?: string;
}

interface TechnicalRequest extends BaseRequest {
  type: RequestType.Technical;
  suggestedIssueId?: string;
  severity: number;
}

type Request = CommercialRequest | AccountingRequest | ProductionRequest | TechnicalRequest;

const getLabelForRequestType = (type: RequestType) => {
  switch (type) {
    case RequestType.Commercial:
      return 'Commerciale';
    case RequestType.Accounting:
      return 'Comptabilité';
    case RequestType.Production:
      return 'Production';
    case RequestType.Technical:
      return 'Technique';
    default:
      return 'Requête';
  }
};

enum RequestStatus {
  TAKING_INTO_ACCOUNT = 'Prise en compte',
  IN_PROCESS = 'En cours de traitement',
  INTERVENTION_SCHEDULED = 'Intervention planifiée',
  WAITING_FOR_CUSTOMER_RETURN = 'En attente de retour client',
  CLOSED = 'Clôturé',
}

export {
  AccountingRequest,
  CommercialRequest,
  ProductionRequest,
  TechnicalRequest,
  RequestType,
  getLabelForRequestType,
  RequestStatus,
  RequestUpdateOptions,
};
export default Request;
